import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ControlsBarContainer = styled(Box)<{$controlsVisible: boolean, $isMobile: boolean}>(({ $controlsVisible, $isMobile }) => {
  return {
    position: "absolute",
    bottom: $isMobile ? "5px" : "5%",
    left: 0,
    right: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 5,
    paddingLeft: $isMobile ? "5px" : "40px",
    paddingRight: $isMobile ? "5px" : "40px",
    transition: "opacity 0.3s ease",
    opacity: $controlsVisible ? 1 : 0,
    pointerEvents: $controlsVisible ? "auto" : "none"
  };
});

export const ControlsBar = styled(Box)<{$isMobile: boolean}>(({ theme, $isMobile }) => {
  return {
    maxWidth: $isMobile ? "100%" : "896px",
    width: "100%",
    backgroundColor: theme.customColors.backgroundPrimary,
    borderRadius: "8px",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    boxShadow: "0 25px 20px -5px #0000001A"
  };
});

export const ProgressBar = styled(Box)(({ theme }) => {
  return {
    position: "relative",
    width: "100%",
    height: "4px",
    borderRadius: "999px",
    backgroundColor: theme.customColors.border
  };
});

export const ProgressBarCompletion = styled(Box)<{$value: number}>(({ theme, $value }) => {
  return {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    width: `${$value}%`,
    backgroundColor: theme.customColors.accentVariantA
  };
});

export const ControlsContainer = styled(Box)(() => {
  return {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  };
});

export const LeftControlsContainer = styled(Box)(() => {
  return {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px"
  };
});

export const ControlsButtonContainer = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "999px",
    backgroundColor: theme.customColors.backgroundPrimaryControl,
    border: `1px solid ${theme.customColors.borderPrimaryControl}`,
    width: "35px",
    height: "35px",
    cursor: "pointer"
  };
});

export const BigPlayButtonContainer = styled(Box)<{$controlsVisible?: boolean, $isPlaying?: boolean}>(({ theme, $controlsVisible, $isPlaying }) => {
  return {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: theme.linearGradients.gradientCarouselCard,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 5,
    transition: "opacity 0.3s ease",
    opacity: ($controlsVisible || !$isPlaying) ? 1 : 0,
    pointerEvents: ($controlsVisible || !$isPlaying) ? "auto" : "none"
  };
});

export const BigPlayButton = styled(Box)(({ theme }) => {
  return {
    width: "60px",
    height: "60px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    backgroundColor: theme.customColors.backgroundPrimaryControl,
    border: `1px solid ${theme.customColors.borderPrimaryControl}`,
    borderRadius: "999px"
  };
});
